import React, { useEffect, useRef, useState } from "react";
import "./CancelPay.scss";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Space,
  Table,
  notification,
} from "antd";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import { columnsCancelPay } from "./CancelPay.config";
import dataCancelPay from "__mocks__/dataCancelPay";
import { payService } from "api";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setCallApi } from "redux/reducer/reduxCommon";
import Notification from "components/common/notification/notification";
import { ModalCustom } from "components/common";

const checkboxOption = [
  { label: "Xem chi tiết", value: "viewDetail" },
  { label: "Xem tất cả", value: "viewAll" },
  { label: "Xem chi phí bằng 0", value: "viewValue0" },
];

const CancelPay = () => {
  const [data, setData] = useState([]);
  const [dataPay, setDataPay] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [limit, setLimit] = useState(null);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const disPath = useAppDispatch();
  const idData = useAppSelector((state) => state.reduxCommon.id);
  const callApi = useAppSelector((state) => state.reduxCommon.callApi);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const modalref = useRef<any>();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  console.log(params);
  
  const [form] = Form.useForm();
  useEffect(() => {
    getListCancelPay();
  }, [params, idData, callApi]);

  // const tachPhanTu = (dataInput) => {
  //   const newData = [];
  //   dataInput.forEach(item => {
  //       if (item.soLuong > 1) {
  //           for (let i = 0; i < item.soLuong; i++) {
  //               const newItem = { ...item, soLuong: 1 };
  //               newData.push(newItem);
  //           }
  //       } else {
  //           newData.push(item);
  //       }
  //   });
  //   return newData;
  // }
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const getListCancelPay = async () => {
    try {
      const response = await payService
        .getListCancelPayById(idData, params.page, params.limit)
        .then((res) => {
         // console.log(res.data);
          setLimit(res.data);
          // notification.success({message: "Lấy dữ liệu thành công"});
          const newData = res.data.data.map((item) => ({
            key: item.id,
            content: item.noiDung,
            bh: item.idTrangThaiBaoHiem,
            ngayChiDinh: item.ngayChiDinh,
            donGiaBenhVien: item.donGiaBenhVien,
            donGiaBaoHiem: item.donGiaBaoHiem,
            soLuong: item.soLuong,
            money: item.thanhTien,
            thoiGianTT: item.thoiGianThanhToan,
            nguoiThanhToan: item.nguoiThanhToan,
            status: item.trangThaiThanhToan,
            reason: item.lyDoHuy,
            timeCancel: item.thoiGianHuyThanhToan,
            nguoiHuy: item.nguoiDungHuyThanhToan,
          }));

          // const newDataTable = tachPhanTu(newData);

          setData(newData);
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách huỷ thanh toán"
      );
      console.log("ERROR", error);
    }
  };

  const handleCancelPay = async () => {
    modalref.current.openModal();
  };

  const submitCancelPay = async (data) => {
    try {
      const response = await payService.getActionCancelPay(data);

      // notification.success({ message: "Thao tác thành công" });
      // disPath(setCallApi());
      handleCancel();
      Notification("success", "Huỷ thanh toán thành công");
    } catch (error) {
      handleCancel();
      Notification("error", error.response.data);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      const selectedRowStatuses = selectedRows.filter((row) => row.status == 1);
      setDataPay(selectedRowStatuses);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const handleSubmit = async () => {
    try {
      if (!dataPay || !dataPay.length) {
        return;
      } else {
        const lyDo = form.getFieldsValue();
        const arrayData = dataPay.map((item) => ({
          id: item.key,
          lydohuy: lyDo.lyDo,
          nguoidunghuy: item.nguoiThanhToan,
        }));
        await submitCancelPay(arrayData);
        getListCancelPay();
        setSelectedRowKeys([]);
        setDataPay([]);
        disPath(setCallApi());
        // setCurrentTab(tabKeys.PAYCHILD.TAB_3);
      }
    } catch (error) {
      console.log("🚀 ~ handleSubmit ~ error:", error);
    }
  };
  const handleCancel = () => {
    modalref.current.closeModal();
    form.resetFields();
  };
  columnsCancelPay.map((e) => {
    if (e.dataIndex == "stt") {
      e.render = (text, record, index) => {
        const rowNumber = (currentPage - 1) * params.limit + index + 1;
        // console.log(rowNumber);

        return rowNumber;
      };
    }
  });
  return (
    <div className="tab-cancel-pay-container">
      <Space direction="vertical" size={"middle"} style={{ width: "100%" }}>
        <Row justify={"end"} align={"middle"}>
          {/* <Col>
            <Checkbox.Group options={checkboxOption} onChange={(e) => {}} />
          </Col> */}
          <Col>
            <Button
              type="primary"
              danger
              onClick={handleCancelPay}
              disabled={!dataPay.length ? true : false}
            >
              Huỷ thanh toán
            </Button>
          </Col>
        </Row>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <Form component={false}>
              <Table
                bordered
                scroll={{ x: 1500 }}
                dataSource={data}
                columns={columnsCancelPay}
                rowSelection={{
                  ...rowSelection,
                }}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: limit?.total,
                  pageSize: limit?.limit,
                  current: limit?.page,
                  onChange: onChangePagination,
                }}
                loading={loadingTable}
              />
            </Form>
          </Col>
        </Row>
        <ModalCustom ref={modalref} title="Huỷ thanh toán">
          <Space direction="vertical" style={{ width: "100%" }}>
            <Form form={form}>
              <Form.Item
                label="Lý do huỷ"
                wrapperCol={{ span: 18 }}
                labelAlign="left"
                labelCol={{ span: 6 }}
                name={"lyDo"}
              >
                <Input />
              </Form.Item>
            </Form>
            <Row justify={"end"} style={{ gap: 5 }}>
              <Button type="primary" onClick={handleSubmit}>
                Xác nhận
              </Button>
              <Button type="primary" danger onClick={handleCancel}>
                Bỏ qua
              </Button>
            </Row>
          </Space>
        </ModalCustom>
      </Space>
    </div>
  );
};

export default CancelPay;
